import { Environment } from '../app/models/environment';
import pkg from '../../package.json';

export const environment: Environment = {
  production: true,
  appVersion: pkg.version,
};
